import { Component, OnInit } from "@angular/core";

@Component({
    selector: 'app-fak',
    templateUrl:'./fak.component.html',
    styleUrls: ['./fak.component.scss']
})
export class FakComponent implements OnInit {

    constructor(){}

    ngOnInit(){
        
    }
}